import { Colors } from "../themes/Colors";

export const formatMessageBody = (body) => {
    // Patterns to match
    const orderNumberRegex = /#\s*\d+/; // Match # with optional space and digits
    const urlRegex = /https?:\/\/[^\s]+|www\.[^\s]+|[^\s]+\.[a-z]{2,}/i;
    const mentionRegex = /@[a-zA-Z0-9_]+/;

    let content = [];
    let currentText = body;
    let keyCounter = 0;

    while (currentText.length > 0) {
        // Check for order number first
        const orderMatch = currentText.match(orderNumberRegex);
        // Check for URL
        const urlMatch = currentText.match(urlRegex);
        // Check for mention
        const mentionMatch = currentText.match(mentionRegex);

        // Find which comes first
        let nextMatch = null;
        let matchType = null;
        let matchIndex = currentText.length;

        if (orderMatch && orderMatch.index !== undefined && orderMatch.index < matchIndex) {
            nextMatch = orderMatch;
            matchType = 'order';
            matchIndex = orderMatch.index;
        }

        if (urlMatch && urlMatch.index !== undefined && urlMatch.index < matchIndex) {
            nextMatch = urlMatch;
            matchType = 'url';
            matchIndex = urlMatch.index;
        }

        if (mentionMatch && mentionMatch.index !== undefined && mentionMatch.index < matchIndex) {
            nextMatch = mentionMatch;
            matchType = 'mention';
            matchIndex = mentionMatch.index;
        }

        if (nextMatch === null) {
            // No more matches, add remaining text
            if (currentText) {
                content.push(currentText);
            }
            break;
        }

        // Add text before match
        if (matchIndex > 0) {
            content.push(currentText.substring(0, matchIndex));
        }

        // Add styled match
        if (matchType === 'order') {
            content.push(
                <span
                    key={`order-${keyCounter++}`}
                    style={{
                        color: '#1E40AF',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        fontWeight: 500
                    }}
                >
                    {nextMatch[0]}
                </span>
            );
        } else if (matchType === 'url') {
            const url = nextMatch[0];
            const hasProtocol = url.startsWith('http://') || url.startsWith('https://');
            const fullUrl = hasProtocol ? url : `https://${url}`;

            content.push(
                <a
                    key={`url-${keyCounter++}`}
                    href={fullUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: Colors.navyBlue, textDecoration: 'underline', cursor: 'pointer' }}
                >
                    {url}
                </a>
            );
        } else if (matchType === 'mention') {
            content.push(
                <span
                    key={`mention-${keyCounter++}`}
                    style={{
                        color: 'rgb(70, 103, 175)',
                        fontWeight: 500,
                        backgroundColor: 'rgba(194, 231, 255, 0.72)',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        display: 'inline-block'
                    }}
                >
                    {nextMatch[0]}
                </span>
            );
        }

        // Move past this match
        currentText = currentText.substring(matchIndex + nextMatch[0].length);
    }

    return content;
};